module.exports = __webpack_public_path__ + "img/plane-lg.15734b03.svg";